export const envVariables = {
    falckdkApiKey: import.meta.env.VITE_FALCKDK_API_KEY,
};
